import $ from "jquery";
import { hasSessionStorage } from "./components/hassessionstorage";
import { overlayOn } from "./components/overlay";
import { listrakRegister } from "./components/listrakRegister";
import ltk from "./components/window._ltk";
import braintree, { BraintreeError } from "braintree-web";
import "@partials/summaryandcheckout";
import type { ApplePaySession } from "braintree-web";

interface MyWindow extends Window {
  pageCart: PageCart;
  authToken: string;
  cartTotal: number;
  ApplePaySession: typeof ApplePaySession;
}

declare const window: MyWindow;

document.addEventListener("click", (e) => {
  if (e.target instanceof Element && e.target.closest(".js-cartitem-remove")) {
    const button = e.target.closest(".js-cartitem-remove");
    if (button !== null) {
      $("#overlaybox").LoadingOverlay("show", {
        background: "rgba(248, 249, 250, 0.8)",
        imageColor: "rgba(52, 58, 64, 1)",
        zIndex: 5000000,
      });
    }
  }
});

document.addEventListener("change", (e) => {
  if (
    e.target instanceof Element &&
    e.target.closest(".js-cartitem-quantity")
  ) {
    const cartitemdata = e.target.closest(".js-cartitem-data") as HTMLElement;
    const quantity = e.target.closest(
      ".js-cartitem-quantity",
    ) as HTMLInputElement;
    if (quantity.value !== cartitemdata.dataset.quantity) {
      const formElement = quantity.closest("form");
      if (formElement !== null && formElement instanceof HTMLFormElement) {
        $("#overlaybox").LoadingOverlay("show", {
          background: "rgba(248, 249, 250, 0.8)",
          imageColor: "rgba(52, 58, 64, 1)",
          zIndex: 5000000,
        });
        formElement.submit();
      }
    }
  }
});

const fasterShipForm = document.querySelector("#fasterShipForm");

if (fasterShipForm instanceof HTMLFormElement) {
  console.log("Faster Ship Form found, adding event listener");
  const shippingModal = document.querySelector("#shippingModal") as HTMLElement;
  //move the shipping modal element from it's current location in the dom to the body
  if (shippingModal.parentElement !== document.body) {
    document.body.appendChild(shippingModal);
  }
  const shipPostalCode = fasterShipForm.querySelector(
    "#shipPostalCode",
  ) as HTMLInputElement;
  const shipCountry = fasterShipForm.querySelector(
    "#shipCountry",
  ) as HTMLSelectElement;
  const shippingModalBody = shippingModal.querySelector(
    "div.modal-body",
  ) as HTMLElement;
  fasterShipForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const $jqButton = $("#calculateShipping");
    $jqButton.LoadingOverlay("show");
    const url = new URL("/cart/deliveryoptions", document.location.toString());
    url.searchParams.append("postalCode", shipPostalCode.value);
    url.searchParams.append("countryCode", shipCountry.value);
    const response = await fetch(url);
    if (response.ok) {
      shippingModalBody.innerHTML = await response.text();
    } else {
      shippingModalBody.innerHTML =
        '<div class="alert alert-danger" role="alert">No delivery options were found.Please try again.</div>';
    }
    $("#shippingModal").modal("show");
    $jqButton.LoadingOverlay("hide");
  });
}

const dataCollect = () => {
  braintree.client.create({
    authorization: window.authToken,
  }, (err, clientInstance) => {
    if(err) {
      return;
    }
    braintree.dataCollector.create({
      client: clientInstance
    }, (dataErr, dataCollectorInstance) => {
      if(dataErr) {
        return;
      }
      const deviceData = dataCollectorInstance.deviceData;
      const deviceDataInputs = document.querySelectorAll(".btDeviceData") as NodeListOf<HTMLInputElement>;
      deviceDataInputs.forEach((input) => {
        input.value = deviceData;
      });
    });
  });
}
dataCollect();

function ShowPayPalButtons() {
  // Create a client.
  braintree.client.create(
    {
      authorization: window.authToken,
    },
    (clientErr: any, clientInstance: any) => {
      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) return;

      // Create a PayPal Checkout component.
      braintree.paypalCheckout.create(
        {
          client: clientInstance,
        },
        (paypalCheckoutErr: any, paypalCheckoutInstance: any) => {
          if (paypalCheckoutErr) return;

          paypalCheckoutInstance.loadPayPalSDK(
            {
              components: "buttons,messages",
              currency: "USD",
              intent: "capture",
              commit: false,
            },
            () => {
              const fundingSources = [
                window.paypal.FUNDING.PAYPAL,
                window.paypal.FUNDING.PAYLATER,
              ];
              fundingSources.forEach((fundingSource) => {
                const button = window.paypal.Buttons({
                  style: {
                    height: 35,
                    shape: "rect",
                    tagline: false,
                  },
                  fundingSource,
                  createOrder() {
                    return paypalCheckoutInstance.createPayment({
                      flow: "checkout", // Required
                      amount: window.cartTotal, // Required
                      currency: "USD", // Required, must match the currency passed in with loadPayPalSDK
                      intent: "capture", // Must match the intent passed in with loadPayPalSDK
                      displayName: "Bowling.com",
                      enableShippingAddress: true,
                      landingPageType: "login",
                    });
                  },

                  onApprove(data) {
                    return paypalCheckoutInstance.tokenizePayment(
                      data,
                      (_err: any, payload: any) => {
                        $("#checkoutActionBox").LoadingOverlay("show");
                        $("#checkoutActionBox2").LoadingOverlay("show");
                        $("#paypalNonce").val(payload.nonce);
                        $("#paypalDetails").val(
                          JSON.stringify(payload.details),
                        );
                        $("#btnPaypalCheckout").click();
                      },
                    );
                  },
                });
                if (button.isEligible()) {
                  if (fundingSource === window.paypal.FUNDING.PAYLATER)
                    document
                      .querySelector("#ppLater")
                      .classList.remove("d-none");
                  button.render(
                    fundingSource === window.paypal.FUNDING.PAYPAL
                      ? "#ppNow"
                      : "#ppLater",
                  );
                }
              });
              if (
                document.querySelector("#pp-pay-later-message") !== null &&
                document.querySelector(".cartTotalAmount") !== null
              ) {
                const totalAmountDiv = document.querySelector(
                  ".cartTotalAmount",
                ) as HTMLElement;
                window.paypal
                  .Messages({
                    style: {
                      text: {
                        align: "center",
                      },
                    },
                    amount: totalAmountDiv.dataset.amount,
                    placement: "payment",
                  })
                  .render("#pp-pay-later-message");
              }
            },
          );
        },
      );
    },
  );
}
if (document.querySelector("#ppNow")) {
  ShowPayPalButtons();
}

const loadApplePay = () => {
  if(!window.ApplePaySession || !window.ApplePaySession.canMakePayments() || !window.ApplePaySession.supportsVersion(3)) {
    console.log("Apple Pay is not available");
    return;
  }
  const applePay = document.querySelector("#applePay") as HTMLElement;
  const applePayButton = document.getElementById("applePayButton") as HTMLElement;
  if (!applePay || !applePayButton) {
    console.log("Apple Pay button not found");
    return;
  }
  applePay.classList.remove("d-none");
  const applePayCreateCallback = (applePayErr: BraintreeError, applePayInstance: any) => {
    if (applePayErr) {
      console.error('Error creating applePayInstance:', applePayErr);
      return;
    }
    applePayButton.addEventListener("click", (e) => {
      const applePayForm = document.querySelector("#applePayForm") as HTMLFormElement;
      const applePayNonceInput = document.querySelector("#applePayNonce") as HTMLInputElement;
      const applePayDetailsInput = document.querySelector("#applePayDetails") as HTMLInputElement;
      
      var paymentRequest = applePayInstance.createPaymentRequest({
        total: {
          label: "Bowling.com",
          amount: window.cartTotal.toFixed(2),
        },
        requiredBillingContactFields: ["postalAddress", "phone"],
        requiredShippingContactFields: ["postalAddress", "phone"],
      });
      
      var session = new window.ApplePaySession(3, paymentRequest);
      
      session.onvalidatemerchant = (event) => {
        applePayInstance.performValidation({
          validationURL: event.validationURL,
          displayName: "Bowling.com",
        }, (validationErr: BraintreeError, validationResponse: any) => {
          if (validationErr) {
            console.error('Error validating merchant:', validationErr);
            session.abort();
            return;
          }
          session.completeMerchantValidation(validationResponse);
        });
      };
      
      session.onpaymentauthorized = (event) => {
        applePayInstance.tokenize({
          token: event.payment.token,
        }, (tokenizeErr: BraintreeError, payload: any) => {
          if (tokenizeErr) {
            console.error('Error tokenizing payment:', tokenizeErr);
            session.completePayment(window.ApplePaySession.STATUS_FAILURE);
            return;
          }
          applePayNonceInput.value = payload.nonce;
          applePayDetailsInput.value = JSON.stringify(event.payment);
          session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
          applePayForm.submit();
        });
      };
      
      session.begin();
    });
  };
  const clientCreateCallback = (clientErr: BraintreeError, clientInstance: any) => {
    if (clientErr) {
      console.error('Error creating client:', clientErr);
      return;
    }
    braintree.applePay.create({
      client: clientInstance
    }, applePayCreateCallback);
  };
  braintree.client.create({
    authorization: window.authToken,
  }, clientCreateCallback);  
};

loadApplePay();

function loadDiscountedItems() {
  $("#inline-itemadded").modal({
    backdrop: "static",
  });
}

$(document).ready(() => {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has("itemadded")) {
    if ($("#inline-itemadded").length > 0) {
      if (hasSessionStorage()) {
        const modalShowsStr = sessionStorage.getItem("modalShows");
        let modalShows = 0;
        if (modalShowsStr === null || modalShowsStr === "null") {
          modalShows = 0;
        } else {
          modalShows = parseInt(modalShowsStr, 10);
        }
        modalShows += 1;
        if (modalShows <= 2) {
          loadDiscountedItems();
          sessionStorage.setItem("modalShows", modalShows.toString());
        }
      } else {
        loadDiscountedItems();
      }
    }
  }

  $("input[data-btntype='remove']").click((index, item) => {
    overlayOn("Removing Item From Cart");
  });
});

$("#btnCheckoutTop").click((event) => {
  event.preventDefault(); // cancel default behavior
  $("#checkoutActionBox").LoadingOverlay("show");
  $("#checkoutActionBox2").LoadingOverlay("show");
  // overlayOn('<i class="fa-solid fa-lock-keyhole"></i>&nbsp;&nbsp;Beginning Checkout');
  window.location.href = "/cart/begincheckout";
});
$("#btnCheckoutBtm").click((event) => {
  event.preventDefault(); // cancel default behavior
  $("#checkoutActionBox").LoadingOverlay("show");
  $("#checkoutActionBox2").LoadingOverlay("show");
  // overlayOn('<i class="fa-solid fa-lock-keyhole"></i>&nbsp;&nbsp;Beginning Checkout');
  window.location.href = "/cart/begincheckout";
});

(() => {
  window.addEventListener(
    "load",
    () => {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      document.querySelectorAll(".needs-validation").forEach((i: Element) => {
        if (i instanceof HTMLFormElement) {
          i.addEventListener(
            "submit",
            (event) => {
              const submitButton = i.querySelector(
                "button[type=submit]",
              ) as HTMLButtonElement;
              submitButton.disabled = true;
              $(submitButton).LoadingOverlay("show");
              if (!i.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
                submitButton.disabled = false;
                $(submitButton).LoadingOverlay("hide");
              }
              i.classList.add("was-validated");
            },
            false,
          );
        }
      });
    },
    false,
  );
})();

document.addEventListener("click", (e) => {
  if (e.target instanceof Element && e.target.closest(".js-showUpsell")) {
    loadDiscountedItems();
  }
});

listrakRegister(() => {
  // eslint-disable-next-line no-underscore-dangle
  ltk.SCA.CartLink = `/cart/storedcart?id=${window.pageCart.storedCartId}`;
  if (window.pageCart.items.length > 0) {
    window.pageCart.items.forEach((f) => {
      if (f.price > 0) {
        // eslint-disable-next-line no-underscore-dangle
        ltk.SCA.AddItemWithLinks(
          f.sku,
          f.quantity,
          f.price.toFixed(2),
          f.name,
          f.imageUrl,
          f.productUrl,
        );
      }
    });
    // eslint-disable-next-line no-underscore-dangle
    ltk.SCA.Submit();
  } else {
    // eslint-disable-next-line no-underscore-dangle
    ltk.SCA.ClearCart();
  }
});

interface PageCart {
  storedCartId: string;
  items: PageCartItem[];
}

interface PageCartItem {
  sku: string;
  quantity: number;
  price: number;
  name: string;
  imageUrl: string;
  productUrl: string;
}
